import { useState } from 'react';
import { useHistory } from 'react-router';
import ProjectGuestViewPreviewPresenter from './ProjectGuestViewPreviewPresenter';
import useAuthSystem from '../../new_arch/modules/authentication/system/useAuthSystem';
import useNavigate from '../../new_arch/navigation/useNavigate';
import { CustomBranding } from '../../new_arch/models/customBranding';

const useProjectGuestViewPreviewPresenter = ( {
	guestHash, projectID, customBranding
}: { guestHash: string, projectID: number, customBranding?: CustomBranding }
) => {
	const history = useHistory();
	const authSystem = useAuthSystem();
	const navigate = useNavigate();

	const createPresenter = () => new ProjectGuestViewPreviewPresenter(
		{ guestHash, projectID, history, authSystem, navigate, customBranding }
	);

	const [ presenter ] = useState( createPresenter );

	return presenter;
}

export default useProjectGuestViewPreviewPresenter;
